export default __webpack_public_path__ + "static/media/image-gallery-2.fa88955a.jpg";